module.exports = __webpack_public_path__ + "static/img/trust-icon1.b6fb2153.png";